<thead>
  <tr class="tableHeader--import">
    <td class="checkbox__row">
      @if (
        ppSite &&
        ppNumberOfSelectableFields !== ppSelectedWorkspaceCustomFields.length &&
        ppNumberOfSelectableFields !== 0
        ) {
        <pp-checkbox
          [ppChecked]="false"
          ppType="solid"
          ppSize="medium"
          (ppOnValueChange)="selectAll()"
        ></pp-checkbox>
      }

      @if (
        ppSite &&
        ppNumberOfSelectableFields === ppSelectedWorkspaceCustomFields.length &&
        ppNumberOfSelectableFields !== 0
        ) {
        <pp-checkbox
          [ppChecked]="true"
          ppType="solid"
          ppSize="medium"
          (ppOnValueChange)="deselectAll()"
        ></pp-checkbox>
      }

      @if (
        ppSite &&
        ppNumberOfSelectableFields === ppSelectedWorkspaceCustomFields.length &&
        ppNumberOfSelectableFields === 0
        ) {
        <pp-checkbox
          [ppChecked]="false"
          [ppDisabled]="true"
          ppType="solid"
          ppSize="medium"
        ></pp-checkbox>
      }
    </td>

    <td class="name__row">{{ 'name' | ppTranslate }}</td>
    <td>{{ 'type' | ppTranslate }}</td>
  </tr>
</thead>
